import React, { useState, useEffect, useRef } from "react";
import "./PageTitle.scss";
import PageTitleButton from "../PageTitleButton";
import { getLocaleString, withLang } from "../Text";
import { useHistory } from "react-router-dom";

const PageTitle = props => {
    const onExpand = () => {
        window.open(
            window.location.href + "#windowed",
            "_blank",
            "toolbar=no,scrollbars=no,resizable=yes,top=500,left=500,width=600,height=800"
        );
    };


    const [isResponsive, setIsResponsive] = useState(false);
    const statusLabel = useRef(null);
    const history = useHistory();

    const isWindowed = () => {
        return window.location.href.includes("#windowed");
    };

    useEffect(() => {
        const handleResize = () => {
            const windowWidth = window.innerWidth;
            if (windowWidth < 768) {
                setIsResponsive(true);
            } else {
                setIsResponsive(false);
            }
        };

        handleResize();

        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);


    const [changeColor,setChangeColor] = useState(true);

    useEffect(()=> {
        const scroller = document.querySelector(".scrollable-content");
        
        const handleScroll = () => {
            if (scroller.scrollTop > 50) 
                setChangeColor(false);
            else setChangeColor(true);
        }

        handleScroll();
        
        scroller.addEventListener("scroll", handleScroll);

        return () => {
            scroller.removeEventListener("scroll", handleScroll);
        }
    }, []);

    useEffect(() => {
        if (!!statusLabel.current) {
            statusLabel.current.style.backgroundColor = props.status.color.bgColor;
            statusLabel.current.style.color = props.status.color.textColor;
        }
    }, [props.status]);
        
    const stickyStyle = props.isSticky
    ? {
        position: "sticky",
        top: 1,
        zIndex: isResponsive ? 0 : 999,
        backgroundColor: changeColor ? "var(--main-app-background-color)" : "rgba(255, 255, 255, 0.8)",
    }
    : {};
    
    return (
        <div 
            style={{
                ...stickyStyle,
                padding: "10px",
                paddingBottom: "0px",
                paddingTop: "5px",
                display: "float",
            }}
        >
            <div
                style={{
                    float: "left",
                    display: "flex",
                }}
            >
                {!!props.status ? (
                    <div className="status-label-padding-box">
                        <div
                            ref={statusLabel}
                            className="status-label"
                        >
                            {props.status.text}
                        </div>
                    </div>
                ) : (
                    ""
                )}

                <div
                    style={{
                        fontSize: "20px",
                        fontWeight: "500",
                        paddingBottom: "15px"
                    }}
                >
                    {props.value}
                </div>
            </div>
            <div
                style={{
                    fontSize: "15px",
                    textAlign: "right",
                    float: "right",
                    display: "flex"
                }}
            >
                {!!props.onCreate ? (
                    <PageTitleButton
                        id="add-new-button"
                        onClick={props.onCreate}
                        icon="fas fa-plus-square"
                        label={getLocaleString(props.lang, "Add_New")}
                        isActive={true}
                    />
                ) : (
                    ""
                )}

                {!!props.onRefresh ? (
                    <PageTitleButton
                        id="refresh-button"
                        onClick={props.onRefresh}
                        icon="fas fa-sync-alt"
                        label={getLocaleString(props.lang, "Refresh")}
                        isActive={true}
                        type={props.refreshButtonType}
                    />
                ) : (
                    ""
                )}

                {props.listOfInjectingButtons?.map(itemButton => {
                    if (!!itemButton.onButton)
                        return (
                            <PageTitleButton
                                key={itemButton.id}
                                id={itemButton.id}
                                onClick={itemButton.onButton}
                                icon={itemButton.icon}
                                label={getLocaleString(props.lang, itemButton.stringButton)}
                                isActive={itemButton.isButtonActive}
                            />
                        );
                    return <></>;
                })}
                {!!props.isValidate ? (
                    <PageTitleButton
                        id="validate-changes-button"
                        onClick={props.onValidate}
                        icon="fas fa-check"
                        label={getLocaleString(props.lang, "Validate")}
                        isActive={true}
                    />
                ) : (
                    ""
                )}
                {!!props.onSave ? (
                    <PageTitleButton
                        id="save-changes-button"
                        onClick={props.onSave}
                        icon="fas fa-save"
                        label={getLocaleString(props.lang, "Save_Changes")}
                        isActive={props.isSaveActive}
                    />
                ) : (
                    ""
                )}

                {!isWindowed() ? (
                    <PageTitleButton
                        id="new-window-button"
                        onClick={onExpand}
                        icon="far fa-window-maximize"
                        label={getLocaleString(props.lang, "New_Window")}
                        isActive={true}
                    />
                ) : (
                    ""
                )}
            </div>
        </div>
    );
};

export default withLang(PageTitle);
